import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Make navbar transparent when at the top of the page (in hero section)
      setIsScrolled(window.scrollY > 50);
    };

    // Check initial scroll position
    handleScroll();

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'DESTINATIONS', path: '/destinations' },
    { name: 'TRIPS', path: '/trips' },
    { name: 'GALLERY', path: '/gallery' },
    { name: 'BLOGS', path: '/blogs' },
    { name: 'CONTACT', path: '/contact' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <img 
            src="/assets/imgs/digital-dream-safaris-logo-light.jpg" 
            alt="Digital Dream Safaris" 
            className="navbar-logo-img"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar-menu">
          <ul className="navbar-links">
            {navLinks.map((link, index) => (
              <li key={index}>
                <Link to={link.path}>{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="navbar-mobile-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle Mobile Menu"
        >
          <span className={`hamburger-icon ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-sidebar-content">
          <button 
            className="mobile-sidebar-close" 
            onClick={toggleMobileMenu}
            aria-label="Close Mobile Menu"
          >
            &times;
          </button>
          <div className="mobile-logo">
            <img 
              src="/assets/imgs/digital-dream-safaris-logo-light.jpg" 
              alt="Digital Dream Safaris" 
            />
          </div>
          <ul className="mobile-nav-links">
            {navLinks.map((link, index) => (
              <li key={index}>
                <Link to={link.path} onClick={toggleMobileMenu}>
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mobile-sidebar-footer">
            <p>© {new Date().getFullYear()} Digital Dream Safaris</p>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
